import { ChangeDetectionStrategy, Component } from '@angular/core';
import type { GridPlugin, GridPluginAttachContext } from '../../core/interfaces/grid-context.types';
import { GRID_PLUGIN } from '../../core/tokens/grid-plugin.token';

/**
 * Plugin de manipulação de colunas. Nesta POC cobre visibilidade (via Store + Bridge);
 * resize com limites e drag-reorder já funcionam nativamente pelo AG Grid a partir de
 * `resizable`/`sortable` no `CompanyColumnDef` — sincronizar a ordem de volta ao Store
 * fica como pendência (ver relatório final).
 */
@Component({
  selector: 'company-grid-column-plugin',
  exportAs: 'companyColumnPlugin',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '',
  providers: [{ provide: GRID_PLUGIN, useExisting: CompanyGridColumnPlugin }],
})
export class CompanyGridColumnPlugin implements GridPlugin {
  readonly pluginId = 'column';

  private context: GridPluginAttachContext | null = null;

  attach(context: GridPluginAttachContext): void {
    this.context = context;
  }

  setColumnVisible(field: string, visible: boolean): void {
    this.context?.store.setColumnVisible(field, visible);
    this.context?.bridge.setColumnVisible(field, visible);
  }

  visibleFields(): readonly string[] {
    return this.context?.store.visibleColumns().map(column => column.field) ?? [];
  }
}
